import { useQuery } from '@apollo/client';

import type {
  PricingPageShopProduct,
  PricingPageShopProductVariables,
} from './__generated__/PricingPageShopProduct';
import PRICING_PAGE_SHOP_PRODUCT_QUERY from './useShopProduct.query';

const useShopProduct = (sku: string | undefined) => {
  const { data, loading, error } = useQuery<
    PricingPageShopProduct,
    PricingPageShopProductVariables
  >(PRICING_PAGE_SHOP_PRODUCT_QUERY, {
    skip: !sku,
    variables: { sku: sku ?? '' },
    fetchPolicy: 'network-only',
  });

  const magentoProduct = data?.magento2?.products?.items?.[0];

  const notFound = !magentoProduct;

  return {
    data,
    loading,
    error,
    magentoProduct,
    notFound,
  };
};

export default useShopProduct;
